import React from 'react';

import fetch from '../fetch';

import moment from 'moment';

import utils from '../../utils';

import { Modal, message } from 'antd';

const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

const transform = (data) => {
    return data.map((d) => {
        var current = {
            label: d.label,
            key: d.id + '',
            value: d.id + ''
        };

        if (d.children) {
            current.children = transform(d.children);
        }
        return current;
    });
}

const codes = (data) => {
    const maps = {};
    data.forEach(d => {
        maps[d.id] = d.label;
    });

    return maps;
}

const headers = utils.columns([
    { type: 'selection' },
    { key: '$index', label: '序号', width: 75 },
    { key: 'orgName', label: '部门', width: 150 },
    { key: 'customerCode', label: '评价人工号', width: 120 },
    { key: 'dudaoName', label: '评价人姓名', width: 120 },
    { key: 'commentCount', label: '评语字数', width: 120, render: (value => (value || 0) + '字') },
    { key: 'bgTermName', label: '开始学期', width: 120 },
    { key: 'endTermName', label: '结束学期', width: 120 },
]);


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    return fetch.post('eval/result/calculateEvalCommentsWord', keywords)
        .then(response => {
            return response.payload.data;
        })
        .then(data => (Object.assign({
            result: data.dataList || [],
            selects: (data.dataList || []).map(d => ({
                value: d.id,
                checked: false
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data.dataList || []).length ? '' : '暂无数据...'
        })));
}

/**
 * @method querySearchTarget
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearchTarget = (keywords = { pageNum: 1, pageSize: 100 }) => {
    return fetch.post('eval/result/target/tree', keywords)
        .then(response => response.payload.data)
        .then(result => {
            const data = transform(utils.tree(result));
            const maps = codes(result);
            return {
                data,
                maps
            }
        })
}


/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'eval/result' + url;
};

const getSelection = () => {
    return DataGrid.selections;
}

/**
 * 数据导出
 * @method exportList
 * @param {object} [keywords]
 * @return {promise}
 */
 const exportList = (keywords) => {
    return fetch.download('eval/result/calculateEvalCommentsWord/export', keywords, "评语字数统计导出.xls")
}

export default {
    querySearch,
    headers,
    onSelect,
    setRefresh,
    redirect,
    querySearchTarget,
    getSelection,
    exportList
}